import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Regions } from '@app/models/regions.model';
import { AdminService } from '@app/services/admin.service';
import { REGION_SOUTH_AMERICA, regionsSouthAmerica } from '@app/utils/constants/regions';
/**
  Componente para mostrar un modal relacionado con la necesidad de sillas especiales.
  Este componente permite gestionar la visualización de pasajeros que requieren sillas especiales
  y cerrar el modal cuando sea necesario.
**/
@Component({
    selector: 'app-tsa-blocker-modal',
    templateUrl: './tsa-blocker-modal.component.html',
    styleUrls: ['./tsa-blocker-modal.component.scss'],
    standalone: false
})
export class TsaBlockerModalComponent implements OnInit, OnDestroy {

  @Input() lang: string;

  regions: string = '';
  terminal: string = '';

  constructor(
    private modalService: NgbModal,
    private _adminService: AdminService
  ) { }

  ngOnInit() {
    this.initPage();
  }

  ngOnDestroy(): void {

  }

  initPage() {
    this.terminal = this._adminService.admin.Terminal || '';
    this.regions = this.regionsDesc(this.lang);
  }

  regionsDesc(lang: string): string {
    const portPinpadRegions = this._adminService.admin.portPinpad || [];

    // Separar regiones de Sudamérica de otras regiones
    const southAmericaRegions = portPinpadRegions.filter(reg => regionsSouthAmerica.includes(reg));
    const otherRegions = portPinpadRegions.filter(reg => !regionsSouthAmerica.includes(reg));

    // Obtener descripciones de otras regiones
    const otherRegionsDesc = otherRegions.map(reg => Regions.find(reg, lang));

    // Crear array final con descripciones únicas
    const allRegionsDesc = [...otherRegionsDesc];

    // Agregar Sudamérica solo una vez si hay regiones de Sudamérica
    if (southAmericaRegions.length > 0) {
      allRegionsDesc.push(REGION_SOUTH_AMERICA[lang === 'es_MX' ? 'es' : 'other']);
    }

    // Formatear el string final con "o"/"or" antes del último elemento
    if (allRegionsDesc.length <= 1) {
      return allRegionsDesc.join('');
    }

    const elements = allRegionsDesc.join(', ');
    const lastComma = elements.lastIndexOf(',');
    return `${elements.slice(0, lastComma)} ${lang === 'es_MX' ? 'o' : 'or'} ${elements.slice(lastComma + 1)}`;
  }

  /**
    Cierra todos los modales abiertos.
    Este método se ejecuta cuando el usuario decide cerrar el modal.
    @return void - No retorna ningún valor.
  **/
  onClose() {
    this.modalService.dismissAll();
  }
}
